// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkSquareFilledSvg from "@fishx/icons-svg/es/asn/DingtalkSquareFilled";
import FishxIcon from '../components/FishxIcon';

var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkSquareFilledSvg
  }));
};

DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
export default React.forwardRef(DingtalkSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DingtalkSquareFilled.js
// module id = 2419
// module chunks = 0